import { useId } from "preact/hooks";

/**
 * An on/off setting that takes effect at once. Rule: the label names what is
 * on ("Guided walkthroughs"), never "Disable …"; use a checkbox in a form
 * that's saved later.
 */
export function Switch({ label, hint, checked, onChange }: { label: string; hint?: string; checked: boolean; onChange: (on: boolean) => void }) {
  const id = useId();
  return <div class="ui-switch-row">
    <span class="ui-switch-row__text"><span id={id}>{label}</span>{hint && <span class="ui-switch-row__hint">{hint}</span>}</span>
    <button type="button" role="switch" class="ui-switch" aria-checked={checked} aria-labelledby={id} onClick={() => onChange(!checked)}><span class="ui-switch__thumb" /></button>
  </div>;
}
